import dayjs from "dayjs"

// round a time string down to the nearest fraction of an hour
export function roundTimeDown(timeString: string, minutesPerCell: number) {
  const minutes = dayjs(timeString).minute()

  const nearestSubdivision = Math.floor(minutes / minutesPerCell)
  const lastHour = dayjs(timeString).startOf("hour")
  return lastHour.add(
    nearestSubdivision * minutesPerCell,
    "minutes",
  )
}
